module.exports = __webpack_public_path__ + "static/media/BAP11-Remake.780bdce6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP11-Remake.png
 ** module id = 677
 ** module chunks = 0
 **/